import { APP, SIDE, RUN_APP, RUN_SIDE } from '@common/loan-act/env'
import { knSendData, ssjSendData } from './send-data'
import { log, warn } from './utils'

import {
  ClassBuryTool,
  BuryToolOptions,
  PositionConfig,
  PositionConfigItem,
  TransferDataBFS,
  BuryParams,
} from './types/bury-tool'

type Way = keyof PositionConfigItem

const firstUpperCase = (str: string) => str.replace(str[0], str[0].toUpperCase())

const _defaultAppMap = {
  [APP.kn]: APP.kn,
  [APP.ssj]: APP.ssj,
}

const _defaultSideMap = {
  [SIDE.app]: SIDE.app,
  [SIDE.h5]: SIDE.h5,
}

/**
 * 生成埋点工具
 */
export default class BuryTool implements ClassBuryTool {
  namespace: string
  positions: PositionConfig = {}
  app: string = ''
  side: string = ''
  way: string = ''
  knStaticParams: object = {}
  ssjStaticParams: object = {}
  knTransferDataBFS: TransferDataBFS | null = null
  ssjTransferDataBFS: TransferDataBFS | null = null

  constructor(
    namespace: string,
    {
      positions,
      transferApp = {}, // 用于映射 app平台和使用的埋点工具 ssj: kn 在随手记平台使用卡牛的埋点上报方式
      transferSide = {}, // 用于映射 端 h5: app 的意思是在h5端仍使用app端的埋点
      knStaticParams = {}, // 卡牛上报工具的一些静态公共参数
      ssjStaticParams = { // 随手记上报工具的一些静态公共参数
        business_type: 'selflabel'
      },
      knTransferDataBFS = null, // function(params) 需要返回一个object,不支持异步，用来添加一些公共动态参数
      ssjTransferDataBFS = null,
    }: BuryToolOptions
  ) {
    this.namespace = namespace

    const _app = {
      ..._defaultAppMap,
      ...transferApp
    }[RUN_APP]
    if (!_defaultAppMap[_app]) {
      warn(`transferTool 配置的映射不在tool范围 (in module [${this.namespace}])`)
      return
    }

    const _side = {
      ..._defaultSideMap,
      ...transferSide
    }[RUN_SIDE]
    if (!_defaultSideMap[_side]) {
      warn(`transferSide 配置的映射不在side范围 (in module [${this.namespace}])`)
      return
    }

    if (typeof positions !== 'object') {
      warn(`埋点配置文件是必传参数，且应是Object类型 (in module [${this.namespace}])`)
      return
    }

    this.positions = positions

    this.app = _app
    this.side = _side
    this.way = this.app + '_' + this.side // eg:kn_app ssj_h5 ...


    this.knStaticParams = knStaticParams
    this.ssjStaticParams = ssjStaticParams
    this.knTransferDataBFS = knTransferDataBFS
    this.ssjTransferDataBFS = ssjTransferDataBFS
  }

  send(key: string, params: BuryParams = {}) {
    const positionConfig = this.positions[key]
    if (!positionConfig) {
      log(`未找到${key}的配置文件 (in module [${this.namespace}])`)
      return
    }

    const buryConf = positionConfig[<Way> this.way]
    if (!buryConf) {
      log(`交叉位置，未配置相应埋点 key=${key}, way=${this.way} (in module [${this.namespace}])`)
      return
    }

    this._fire(buryConf, params)
  }

  _fire(config: object, params: object) {
    let fire
    if (this.app === APP.kn) {
      fire = this._fireKn.bind(this)
    } else {
      fire = this._fireSsj.bind(this)
    }
    fire(config, params)
  }

  _fireKn(config: {
    [x: string]: any;
  }, params: object) {
    const { newaction, custom1, etype } = config
    let postData = {
      newaction,
      custom1: custom1 || '',
      etype: firstUpperCase(etype || 'click'),
      ...this.knStaticParams,
      ...params
    }
    if (typeof this.knTransferDataBFS === 'function') {
      const res = this.knTransferDataBFS(postData)
      postData = {
        ...postData,
        ...res
      }
    }
    knSendData(postData)
  }

  _fireSsj(config: object, params: object) {
    let postData = {
      ...this.ssjStaticParams,
      ...config,
      ...params
    }
    if (typeof this.ssjTransferDataBFS === 'function') {
      const res = this.ssjTransferDataBFS(postData)
      postData = {
        ...postData,
        ...res
      }
    }
    ssjSendData(postData)
  }
}